import { Link, useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { fadeInUp } from '../lib/animations';
import { XCircle, ArrowLeft, Mic2 } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function OrderCancel() {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('order_id');

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center p-4">
      <motion.div
        {...fadeInUp}
        className="max-w-md w-full bg-surface border border-[#262626] rounded-2xl p-8 text-center"
      >
        <Link to="/" className="inline-flex items-center gap-2 mb-8">
          <div className="w-8 h-8 bg-lime rounded-full flex items-center justify-center">
            <Mic2 className="w-4 h-4 text-black" />
          </div>
          <span className="font-heading font-bold text-lg">Tune4Tune</span>
        </Link>

        <div className="w-20 h-20 mx-auto mb-6 bg-red-500/20 rounded-full flex items-center justify-center">
          <XCircle className="w-10 h-10 text-red-400" />
        </div>

        <h1 className="font-heading text-2xl font-bold mb-2">Payment Cancelled</h1>
        <p className="text-[#A1A1AA] mb-8">
          Your payment was cancelled. No charges have been made to your account.
        </p>

        <div className="flex flex-col gap-3">
          <Link to="/">
            <Button className="w-full btn-primary">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Artists
            </Button>
          </Link>
          {orderId && (
            <p className="text-xs text-[#666]">Order ID: {orderId.slice(0, 8)}</p>
          )}
        </div>
      </motion.div>
    </div>
  );
}
